import { moduleBorderBottom } from '@/helpers/environmentHelper';
import { useAppDispatch } from '@/state/hooks';
import { setIsDragging } from '@/state/reducers/mosaicSlice';
import cn from 'classnames';
import { useCallback } from 'react';
import { isTablet } from 'react-device-detect';
import { MosaicWindow } from 'react-mosaic-component';

export const moduleHeaderClassName = cn(
    'flex justify-between items-center w-full h-full text-brand-module-title',
    moduleBorderBottom
);

const ModuleWindow = ({ path, screen, tradingModule, renderToolbar, children }: any) => {
    const dispatch = useAppDispatch();

    const dragStart = useCallback(() => {
        dispatch(setIsDragging(true));
    }, []);

    const dragEnd = useCallback(() => {
        dispatch(setIsDragging(false));
    }, []);

    return (
        <MosaicWindow<string>
            path={path}
            title={tradingModule?.title}
            draggable={(screen.laptop || screen.desktop) && !isTablet}
            onDragStart={dragStart}
            onDragEnd={dragEnd}
            renderToolbar={renderToolbar}>
            {children}
        </MosaicWindow>
    );
};

export default ModuleWindow;
